import Vue from 'vue'
import ElementUI from 'element-ui'
import viLocale from 'element-ui/lib/locale/lang/vi'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import App from './App'
import store from './store/index'
import routes from './router/routes'
import i18n from './i18n'
import Prototype from "./addon/prototype";
import Filter from "./addon/filter";
import Directive from "./addon/directive";
import ShopSelectComponent from './components/shop_select.vue'
import './assets/tailwind.css'
import 'bootstrap/dist/css/bootstrap.css'

// Install modules
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(ElementUI, {locale: viLocale})

// Install addons
Vue.use(Prototype)
Vue.use(Filter)
Vue.use(Directive)

// Install global components
Vue.component('shop-select', ShopSelectComponent)

// Check local storage to handle refreshes
if (window.localStorage) {
    const session = localStorage.getItem('session')
    store.dispatch('update_userInfo', JSON.parse(session) !== null ? JSON.parse(session) : {})
        .catch(console.error)
}

const router = new VueRouter({
    routes: routes,
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: function (to, from, savedPosition) {
        return savedPosition || {
            x: 0,
            y: 0
        }
    }
})

new Vue({
    el: '#app',
    router: router,
    store: store,
    i18n: i18n,
    render: h => h(App),
    beforeMount() {
        this.EB.$on('quick_confirm', data => {
            this.$confirm(data.message, i18n.t('base.attention'), {
                type: 'warning',
                confirmButtonText: i18n.t('base.confirm'),
                cancelButtonText: i18n.t('base.cancel')
            })
                .then(() => {
                    data.callback()
                })
                .catch(error => {
                    console.log('ERROR_CALLBACK==================================')
                    console.log(error)
                })
        })
        this.EB.$on('NTF_error', data => {
            this.$notify({
                type: 'error',
                title: i18n.t('base.error'),
                message: typeof data === 'string' ? data : data.body.message || i18n.t('base.system_error')
            })
        })
        this.EB.$on('NTF_success', data => {
            this.$notify({
                type: 'success',
                title: i18n.t('base.notification'),
                message: typeof data === 'string' ? data : data.body.message || i18n.t('base.update_success')
            })
        })
        this.EB.$on('NTF_warning', data => {
            this.$notify({
                type: 'warning',
                title: i18n.t('base.attention'),
                message: typeof data === 'string' ? data : (data.body && data.body.message ? data.body.message : i18n.t('base.has_an_occurred'))
            })
        })

        this.EB.$on('CFM_warning', data => {
            this.$confirm(data, i18n.t('base.attention'), {
                showConfirmButton: false,
                showCancelButton: false,
                type: 'warning'
            })
                .then(null)
                .catch(null)
        })
    },
    beforeDestroy() {
        this.EB.$off('quick_confirm')
        this.EB.$off('NTF_error')
        this.EB.$off('NTF_success')
        this.EB.$off('NTF_warning')
        this.EB.$off('CFM_warning')
    }
})

require('bootstrap')
require('../node_modules/admin-lte/dist/js/app.min.js')
require('../node_modules/admin-lte/dist/js/demo.js')
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js')



// WEBPACK FOOTER //
// ./src/main.js